var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":_vm.transition}},[(_vm.isVisible)?_c('div',{staticClass:"loading-wrapper",class:{ 'is-small': _vm.isSmall, 'is-full-screen': _vm.isFullScreen },attrs:{"id":"loading-wrapper"}},[_c('div',{staticClass:"loading__spinner"}),_c('p',{style:({
        color: _vm.color,
        fontSize: _vm.fontSize
      })},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }